import React from 'react';

import {
  Button,
  Container,
  CountIndicator,
  IndicatorText,
} from './styledComponents';

type Props = {
  isActive?: boolean;
  indicatorText?: string | number;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  children: React.ReactNode;
  tooltipText?: string;
};

const MapControlButton: React.FC<Props> = ({
  isActive,
  indicatorText,
  onClick,
  children,
  tooltipText,
}) => (
  <Container>
    <Button data-tip={tooltipText} isActive={isActive} onClick={onClick}>
      {children}
    </Button>
    {!!indicatorText && (
      <CountIndicator>
        <IndicatorText>{indicatorText}</IndicatorText>
      </CountIndicator>
    )}
  </Container>
);

export default React.memo(MapControlButton);
